import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Typography } from '@mui/material';
import { useMemo } from 'react';
import { useContextObjectSwitch } from '../../../hooks/useContextObjectSwitch';
/**
 * # DO NOT USE
 *
 * This component _only_ exists for viewing and analysis in the `WIDGET_PLAYGROUND`
 */
export const useContextObjectSwitchWidget = (props) => {
    const { components } = useContextObjectSwitch({
        contextCustomer: props.contextCustomer ?? {},
        user: props.user ?? {},
        navSection: 'GoogleMap',
    });
    const component = useMemo(() => (_jsxs(Stack, { gap: 1, children: [_jsx(Typography, { variant: "h5", children: "modeRadioButtons" }), components.modeRadioButtons, _jsx(Typography, { variant: "h5", children: "contextObjectSelector" }), components.contextObjectSelector] })), [components]);
    return {
        name: 'useContextObjectSwitch',
        category: 'hooks',
        component,
    };
};
